// removed by extract-text-webpack-plugin
module.exports = {"value":"StackedBar__value___3RYj0","chart":"StackedBar__chart___DnH-z","expand":"StackedBar__expand___1LddL","block":"StackedBar__block___3ZrsG","Material":"StackedBar__Material___3KE8X","Labor":"StackedBar__Labor___HiUoB","Overhead":"StackedBar__Overhead___2MZXk","Profit":"StackedBar__Profit___V1FZl","Tooling":"StackedBar__Tooling___2WQ5d","Other":"StackedBar__Other___2axh3","toolTip":"StackedBar__toolTip___xORYX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StackedBarChart/StackedBar/StackedBar.less
// module id = 1241
// module chunks = 0